import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { WidgetAuthService } from '../services/platform/widget-auth.service';
import { WIDGET_ERROR_PATH } from '../components/widget-error/widget-error.component';

/**
 * The widget only loads with a valid `api_key` query parameter; without one the visitor
 * gets WidgetErrorComponent and none of the app behind it.
 *
 * The error page is rendered with `skipLocationChange`, so the address bar keeps the
 * original `widget.<domain>/?...` URL: an embedding iframe holds on to its `src`, and a reload
 * retries with the same key once it is fixed.
 */
export const widgetApiKeyGuard: CanActivateFn = () => {
  const router = inject(Router);

  return inject(WidgetAuthService).validate().pipe(
    map((valid) => {
      if (valid) return true;
      router.navigateByUrl(`/${WIDGET_ERROR_PATH}`, { skipLocationChange: true });
      return false;
    }),
  );
};
